const API = 'Pages';

export const API_PAGES = {
  LAYOUT: `${API}/GetPageLayout`,
  PRIVACY: `${API}/GetPrivacyPolicy`,
  TERMS: `${API}/GetTermsAndConditions`,
};

export interface BasePage {
  id: string;
  languageID: string;
  title: string;
  html: string;
  generalBodyScripts: string;
  generalFooterScripts: string;
  generalHeaderScripts: string;
  googleAnalyticScripts: string;
  fullStoryCode: string;
  metaTitle: string;
  metaDescription: string;
  metaKeyWords: string;
}
